import { createFileRoute } from '@tanstack/react-router'
import React from 'react';
import { useNavigate, useParams, useRouterState } from '@tanstack/react-router';
import Layout from '@/components/Layout';
import { useI18n } from '@/hooks/useI18n';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeftIcon, PlusIcon } from '@heroicons/react/24/outline';

export default function NewMenuItemPage() {
    const { t } = useI18n();
    const navigate = useNavigate();
  const params = useParams({ strict: false });
  const routerState = useRouterState();

    const handleBack = () => {
        navigate({ to: '/menus'});
    };

    return (
        <Layout>
            <div className="space-y-6">
                {/* Header */}
                <div className="flex items-center gap-4">
                    <Button variant="ghost" onClick={handleBack} className="flex items-center gap-2">
                        <ArrowLeftIcon className="h-4 w-4" />
                        Back to Menu Items
                    </Button>
                    <div>
                        <h1 className="text-3xl font-bold tracking-tight">
                            Create New Menu Item
                        </h1>
                        <p className="text-muted-foreground">
                            Add a new item to your menu
                        </p>
                    </div>
                </div>

                {/* Placeholder Content */}
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <PlusIcon className="h-5 w-5" />
                            New Menu Item Form
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="p-6 text-center text-muted-foreground">
                        <div className="space-y-4">
                            <PlusIcon className="h-16 w-16 mx-auto opacity-50" />
                            <div>
                                <h3 className="text-lg font-semibold text-foreground mb-2">
                                    Create Menu Item Form
                                </h3>
                                <p>
                                    This form will allow you to create new menu items with:
                                </p>
                                <ul className="text-sm mt-2 space-y-1">
                                    <li>• Basic information (name, description)</li>
                                    <li>• Pricing (base price, cost price)</li>
                                    <li>• Category assignment</li>
                                    <li>• Status and availability settings</li>
                                    <li>• Location-specific variants</li>
                                </ul>
                            </div>
                            <div className="pt-4">
                                <p className="text-sm italic">
                                    Form implementation coming soon...
                                </p>
                                <Button
                                    onClick={handleBack}
                                    className="mt-4"
                                >
                                    Return to Menu Items
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </Layout>
    );
}

export const Route = createFileRoute('/menus/new')({
  component: NewMenuItemPage,
})
